/**
 * Tabs component
 * 
 * @module component-tabs
 * @version 1.0.0
 * @extends HTMLElement
 */

 customElements.component = 'component-tabs';

 if (!customElements.get(customElements.component)) {
 
     class Tabs extends HTMLElement {
 
        /**
         * Tabs web component
         * 
         * @constructor
         */
        constructor() {
 
            super();
 
            this.initEvents();

         }
         
         /**
          * Init component events
          * 
          * @returns {undefined}
          */
         initEvents() {

            this.tabs = this.querySelectorAll('[data-tab-heading-index]');
            this.contents =  this.querySelectorAll('[data-tab-content-index]');
            this.tabsQty = this.contents.length || 0;

            this.tabs.forEach( (tab) => {
                tab.addEventListener('click', (event) => {
                    event.preventDefault();
                    this.activateTab(tab.dataset.tabHeadingIndex);
                });

                tab.addEventListener('keydown', (event) => {
                    //event.preventDefault();
                    this.keydownBehavior(event.keyCode);
                });
            });

            //Select first tab
            if(this.tabs[0]){
                this.tabs[0].click();
            }
  
         }
 
        /**
         * Activate Tab
         * 
         * @param {integer} index Selected tab index.
         */
 
        activateTab(index) {
            this.activeIndex = index;

            // Disable all active tabs
            this.tabs.forEach((tab) => {
                tab.parentElement.classList.remove('active');
                tab.classList.remove('active');
                tab.setAttribute("aria-selected", false);
                tab.setAttribute("tab-index", "-1");
            });

            this.contents.forEach((content) => {
                content.classList.remove('active');
            });

            // Enable all active classes
            this.tabs[this.activeIndex].parentElement.classList.add('active');
            this.tabs[this.activeIndex].classList.add('active');
            this.tabs[this.activeIndex].setAttribute("aria-selected", true);
            this.tabs[this.activeIndex].setAttribute("tab-index", "0");
            this.contents[this.activeIndex].classList.add('active');
        }

        /**
         * keydown Behavior
         * 
         * @param {integer} keyCode Key Code.
         */

        keydownBehavior(keyCode){
            let activatedIndex = this.activeIndex;
            let maxIndex = this.tabs.length - 1;
            let newIndex = -1;

            // Left / Up arrow
            if (keyCode === 37 || keyCode === 38) {
                newIndex = (activatedIndex === 0) ? maxIndex : activatedIndex - 1;
            }

            // Right arrow / Down arrow
            if (keyCode === 39 || keyCode === 40) {
                newIndex = (activatedIndex === maxIndex) ? 0 : activatedIndex + 1;
            }

            if (newIndex > -1) {
                this.activateTab(parseInt(newIndex));
                this.tabs[this.activeIndex].focus();
            }
        }
         
     }
 
     customElements.define(customElements.component, Tabs);
 }